export default __webpack_public_path__ + "static/media/Close01.a37a7687.svg";